import { createContext, useContext } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

const LanguageContext = createContext()

// Greek pages live under /el (e.g. /el/pricing, home is /el/), English at the
// root. The language comes from the URL, not from state, so each language has
// its own crawlable address and Google can index both.
export const EL_PREFIX = '/el'

export function langFromPath(pathname) {
  return pathname === EL_PREFIX || pathname.startsWith(`${EL_PREFIX}/`) ? 'el' : 'en'
}

// '/el/pricing' -> '/pricing', '/el/' -> '/'
export function stripLang(pathname) {
  if (langFromPath(pathname) !== 'el') return pathname
  return pathname.slice(EL_PREFIX.length) || '/'
}

// ('/pricing', 'el') -> '/el/pricing', ('/', 'el') -> '/el/'
export function localizePath(path, lang) {
  if (lang !== 'el') return path
  return path === '/' ? `${EL_PREFIX}/` : `${EL_PREFIX}${path}`
}

export function LanguageProvider({ children }) {
  const location = useLocation()
  const navigate = useNavigate()
  const lang = langFromPath(location.pathname)

  const setLang = (next) => {
    if (next === lang) return
    navigate(localizePath(stripLang(location.pathname), next) + location.search + location.hash)
  }

  return (
    <LanguageContext.Provider value={{ lang, setLang }}>
      {children}
    </LanguageContext.Provider>
  )
}

export function useLanguage() {
  return useContext(LanguageContext)
}
